<script setup>
import { onMounted, ref } from 'vue'
import { useRouter, onBeforeRouteUpdate } from 'vue-router'
import { useRaaiMembersStore } from '@/store/raaiMembers'

const router = useRouter()

const raaiMembersStore = useRaaiMembersStore()
const regionalBranches = ref([])
const headers = ref([
    { title: 'Региональное отделение', key: 'regionalBranch' },
    { title: 'Председатель', key: 'chairman' },
    { title: 'Почтa', key: 'email' }
])

const data = ref([
    {
        id: 1,
        title: 'РЕГИОНАЛЬНЫЕ ОТДЕЛЕНИЯ РАИИ',
        text: ''
    },
    {
        id: 2,
        title: 'ПОЛОЖЕНИЕ О РЕГИОНАЛЬНЫХ ОТДЕЛЕНИЯХ РАИИ',
        text: '<p><strong>Общие положения</strong></p><ol><li><p>Региональные отделения Ассоциации действуют на основании Устава РАИИ. Высшим руководящим органом регионального отделения является Общее собрание его членов, проводимое не реже одного раза в год. Общее собрание правомочно, если на нем присутствует большинство членов отделения. Решения принимаются большинством голосов присутствующих на Общем собрании членов отделения. Общее собрание решает любые вопросы деятельности отделения Ассоциации. В период между Общими собраниями руководство отделением осуществляет Председатель, избираемый Общим собранием отделения сроком на 3 года.</p></li><li><p>Председатель регионального отделения Ассоциации автоматически включаются в состав Совета.</p></li><li><p>Количество членов регионального отделения должно быть не менее трех человек.</p></li></ol><p style="text-align: start"><strong>Создание региональных отделений РАИИ</strong></p><p style="text-align: start">Для создания регионального отделения следует выполнить следующие процедуры:</p><ol><li><p>Провести т.н. учредительное собрание.</p></li><li><p>Избрать:</p><ul><li><p>председателя Отделения,</p></li><li><p>секретаря Отделения,</p></li><li><p>заместителя (заместителей) председателя.</p></li></ul></li><li><p>Запротоколировать это собрание, указав:</p><ul><li><p>список участников,</p></li><li><p>результаты выборов (возможно в виде протокола счетной комиссии).</p></li></ul></li><li><p>Выслать на имя президента РАИИ ассоциации письмо - заявление, содержащие слова "Просим рассмотреть вопрос о регистрации регионального отделения ...". К письму прилагается протокол учредительного собрания и список членов регионального отделения.</p></li></ol><p style="text-align: start"><strong>Примечания</strong></p><ol><li><p>Список членов регионального должен содержать: ФИО (полностью), место работы, должность, контактные данные и основные труды в области ИИ (РАИИ является ассоциацией <strong>специалистов</strong> в области ИИ).</p></li><li><p>Письмо может быть отослано на имя президента РАИИ, ученого секретаря или одного из вице-президентов РАИИ.</p></li></ol>'
    }
])

const currentData = ref({})

const changeCurrentData = (subLink) => {
    if (subLink === 'main') {
        currentData.value = data.value[0]
    } else if (subLink === 'regulations') {
        currentData.value = data.value[1]
    }
}

onBeforeRouteUpdate((to) => {
    changeCurrentData(to.params.subLink)
})

onMounted(async () => {
    changeCurrentData(router.currentRoute.value.params.subLink)

    if (router.currentRoute.value.params.subLink === 'main') {
        await raaiMembersStore.getRegionalBranches()
        regionalBranches.value = raaiMembersStore.formatRegionalBranches
    }
})
</script>

<template>
    <h1 class="about_raai_regional_branches_title">{{ currentData.title }}</h1>
    <div
        v-if="router.currentRoute.value.params.subLink !== 'main'"
        class="about_raai_regional_branches_text"
        v-html="currentData.text"
    />
    <div
        v-else
        class="table"
    >
        <v-data-table
            :headers="headers"
            :items="regionalBranches"
            items-per-page-text="Элементов на странице:"
            :items-per-page-options="[
                { value: 10, title: '10' },
                { value: 25, title: '25' },
                { value: 50, title: '50' },
                { value: 100, title: '100' },
                { value: -1, title: 'Все' }
            ]"
        />
    </div>
</template>

<style lang="scss">
.about_raai_regional_branches_title {
    font-size: 36px;
    font-weight: 600;
    line-height: 40px;
    color: #0635ac;
    text-align: left;

    @media screen and (max-width: 767px) {
        font-size: 28px;
        line-height: 36px;
        text-align: left;
    }
}

.v-table {
    text-align: left;
    margin-top: 15px;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;

    .v-table__wrapper {
        table {
            thead {
                tr {
                    th {
                        font-weight: 600 !important;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 767px) {
        font-size: 14px;
    }
}
</style>
